<template lang="pug">
.activities-team-status
  h5.organization {{ orgName }} team members
  AppButton.btn-naked.vue-onboarding-trigger(
    type="block"
    @click="showOnboardingStatusDialog()"
  )
    .hi.hi-16.hi-users.pr-5
    | View onboarding status
  InvitesOnboardingStatusDialog(
    ref="InvitesStatusDialog"
    :organization-id="orgId"
  )
</template>

<script>
import InvitesOnboardingStatusDialog from '../invites/InvitesOnboardingStatusDialog.vue';

export default {
  name: 'ActivitiesTeamStatus',
  components: {
    InvitesOnboardingStatusDialog,
  },
  props: {
    orgId: {
      type: Number,
      required: true,
    },
    orgName: {
      type: String,
      required: true,
    },
  },
  methods: {
    showOnboardingStatusDialog() {
      this.$refs.InvitesStatusDialog.open();
    },
  },
};
</script>
